import React, { useState, useCallback } from "react"

import { getFormattedMessage } from "../../../../components/shared_components_registration"

/*
 * Input field + button to update the number of days worth of data to load (relative to present)
 * */
export default function DayCutoffFilter({ intl, cutoff, disabled = false, loading = false, setCutoff }) {
  // Variables for updating runs cutoff
  const [newCutoff, setNewCutoff] = useState(cutoff || 7)
  const [cutoffBorderColor, setCutoffBorderColor] = useState("var(--lanzalake-grey)")
  // --- / Variables for updating runs cutoff

  const onChange = useCallback((e) => {
    let value = e.target.value
    if (value) {
      value = value < 1 ? 1 : parseFloat(value)
    }
    setCutoffBorderColor("var(--lanzalake-orange)")
    setNewCutoff(value)
  }, [])

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault()
      if (newCutoff) {
        setCutoffBorderColor("var(--lanzalake-grey)")
        setCutoff(newCutoff)
      } else {
        setCutoffBorderColor("var(--lanzalake-red)")
      }
    },
    [newCutoff],
  )

  return (
    <div
      style={{
        border: `1px solid ${cutoffBorderColor}`,
        borderRadius: "3px",
        padding: "3px",
        backgroundColor: "var(--lanzalake-grey-light-2)",
      }}
    >
      <label style={{ margin: "0", fontSize: "85%" }}>
        {getFormattedMessage("graphing.timelabel.day", "Days", true, intl)}
      </label>
      :&nbsp;
      <input
        type={"number"}
        onWheel={(e) => e.target.blur()}
        step={"0.1"}
        value={newCutoff}
        style={{ width: "50px" }}
        disabled={loading || disabled}
        onChange={onChange}
      />
      &nbsp;
      <button
        className="btn btn-outline-primary btn-sm"
        type="button"
        disabled={loading || disabled || newCutoff === cutoff}
        onClick={onSubmit}
      >
        {loading ? <span className="fa fa-hourglass-half" /> : <span className="fa fa-search" />}
      </button>
    </div>
  )
}
